module.exports = __webpack_public_path__ + "static/img/tab_active_3.34838c21.png";